/**
 * Agend Data Layer - Shared Tracking Utilities
 *
 * Common functions used across tracking modules.
 */

'use strict';

/**
 * Check if tracking is enabled for a specific feature
 *
 * @param {string} feature - Feature key in agendDataLayerConfig
 * @return {boolean} True if enabled
 */
export function isTrackingEnabled(feature) {
	return !!window.agendDataLayerConfig?.[feature];
}

/**
 * Create standardized GA4 item/product data object
 *
 * @param {Object} options - Product data options
 * @param {string} options.sku - Product SKU
 * @param {string} options.name - Product/item name
 * @param {number} options.price - Unit price
 * @param {number} options.quantity - Quantity
 * @param {string} [options.category] - Item category
 * @param {string} [options.stockStatus] - Stock status
 * @param {number} [options.stockLevel] - Stock level
 * @return {Object} GA4-compliant item object
 */
export function createItemData(options) {
	const itemData = {
		item_id: options.sku,
		id: options.sku,
		sku: options.sku,
		item_name: options.name,
		price: options.price,
		quantity: options.quantity,
		google_business_vertical: 'retail'
	};

	// Add optional properties
	if (options.category) {
		itemData.item_category = options.category;
	}
	if (options.stockStatus) {
		itemData.stockstatus = options.stockStatus;
	}
	if (options.stockLevel !== undefined) {
		itemData.stocklevel = parseInt(options.stockLevel, 10);
	}

	return itemData;
}

/**
 * Push GA4 add_to_cart event to dataLayer
 *
 * @param {Array} items - Array of item objects
 * @param {string} [currency='AUD'] - Currency code
 */
export function pushAddToCartEvent(items, currency) {
	if (!items || items.length === 0) {
		return;
	}

	// Initialize dataLayer if it doesn't exist
	window.dataLayer = window.dataLayer || [];

	const totalValue = items.reduce(function (sum, item) {
		return sum + (item.price * item.quantity);
	}, 0);

	window.dataLayer.push({
		event: 'add_to_cart',
		ecommerce: {
			currency: currency || 'AUD',
			value: totalValue,
			items: items
		}
	});
}
